import { FieldProps } from 'formik';
import React, { useState } from 'react';

import styles from './InputStyles.module.scss';

type Props = {
  id: string;
  disabled: boolean;
  onValuesChanged: (value: boolean) => void;
  readOnly: boolean;
};
/**
 * Toggle component as an alternative to checkbox fields
 *
 * Props:
 * @param {string} id
 * @param {boolean} disabled Used to determine if the toggle field is disabled
 * @param {string} name Name of the field, helpful for formik
 * @param {Func} onValuesChanged Callback function to be executed when the toggle value is changed
 * @param {boolean} readOnly Used to determine if the field is read only
 * @param {formik.FieldProps } field Formik field reference for updating values and getting name
 * @param  form Formik form to use to set the value of the fields in formik using setFieldValue
 *
 */

// let initialChecked: boolean;
const ToggleField: React.FC<React.PropsWithChildren<Props & FieldProps>> = ({
  id,
  disabled,
  onValuesChanged,
  readOnly,
  field,
  form,
}) => {
  const [checked, setChecked] = useState(field.value);

  const handleCheckChanged = () => {
    const newValue = !checked;

    setChecked(newValue);
    form.setFieldValue(field.name, newValue);
    onValuesChanged(newValue);
  };

  return (
    <div className={styles.toggleWrapper}>
      <input
        id={id}
        name={field.name}
        checked={checked}
        className={styles.mobileToggle}
        disabled={disabled || readOnly}
        onChange={handleCheckChanged}
        readOnly={readOnly}
        type="checkbox"
      />
      <label htmlFor={id}> </label>
    </div>
  );
};

export default ToggleField;
